import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'lodash',
})
export class LodashPipe implements PipeTransform {
  transform(value: string, ...args) {
    const fn = _[args[0]];
    args[0] = value;
    if (fn) {
      return fn.apply(_, args);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/lodash/lodash.ts